"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _helpSnippet = _interopRequireDefault(require("./help-snippet"));
var _utils = require("../utils");
var _processRichText = _interopRequireDefault(require("../utils/process-rich-text"));
var _standard = _interopRequireDefault(require("../utils/rich-text-factories/standard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var createHelpSnippets = function createHelpSnippets(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  var document = (0, _utils.getProp)(fields, 'intro');
  var intro = document ? (0, _processRichText["default"])({
    document: document,
    factories: _standard["default"]
  }) : null;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    title: (0, _utils.getProp)(fields, 'title'),
    intro: intro,
    snippets: fields !== null && fields !== void 0 && fields.snippets ? (0, _utils.filterItemsBySite)(fields.snippets).map(function (snippet) {
      return (0, _helpSnippet["default"])(snippet);
    }) : []
  };
};
var _default = createHelpSnippets;
exports["default"] = _default;